export default __webpack_public_path__ + "static/media/baby_start_image.24d026e9.png";